/* RESPONSIBLE TEAM: team-automation-foundations */
import Controller from '@ember/controller';

export default class SettingsAIAutomationFinAiAgentController extends Controller {
  queryParams = ['section'];
}
